export const API_URL = process.env.VUE_APP_SERVER_URL;
export default API_URL;
